import { useSelector } from 'react-redux';
import { getFormValues } from 'redux-form/immutable';
import { CHECKOUT_FORM_TITLE } from '../components/form/constants';
import type { CheckoutReduxForm } from '../types/checkout-redux-form';

export const useLegacyCheckoutForm = (): CheckoutReduxForm => {
  const formValues = useSelector(getFormValues(CHECKOUT_FORM_TITLE, (state) => state.form)) as any;

  return formValues.toJSON();
};
